// This file is not yet translated.
/* eslint-disable i18next/no-literal-string */
import {
  Box,
  Button,
  Chip,
  Icon,
  OsCard,
  OsCardMedia,
  Theme,
  Typography,
} from "@outschool/backpack";
import { faStar } from "@outschool/icons";
import { useIsMobile } from "@outschool/ui-utils";
import React from "react";

interface MixTopicCardProps {
  title: string;
  imageUrl: string;
  isDefault: boolean;
  isSelected: boolean;
  onCardClick: () => void;
  onButtonClick: () => void;
}

export default function MixTopicCard({
  title,
  imageUrl,
  isDefault,
  isSelected,
  onCardClick,
  onButtonClick,
}: MixTopicCardProps) {
  const isMobile = useIsMobile();
  return (
    <OsCard
      onClick={onCardClick}
      color={isDefault ? "primary" : "warning"}
      selected={isSelected}
      padding={0}
    >
      <Box
        sx={(theme: Theme) => ({
          display: "flex",
          flexDirection: "column",
          padding: "0.75em",
          width: 160,
          height: 225,
          gap: "0.25em",
          [theme.breakpoints.up("sm")]: {
            width: 224,
            height: 292,
            gap: "0.75em",
          },
        })}
      >
        {isDefault ? (
          // same size as the chip to keep alignment
          <Box sx={{ height: "21px" }} />
        ) : (
          <Chip
            label="My Mix"
            size="small"
            color="warning"
            icon={<Icon icon={faStar} />}
            sx={{ alignSelf: "flex-start" }}
          />
        )}
        <OsCardMedia
          image={imageUrl}
          alt={title}
          interactiveEffect="zoom"
          height={isMobile ? "91px" : "134px"}
        />
        <Typography
          variant="subtitle1"
          sx={{
            overflow: "hidden",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            textOverflow: "ellipsis",
          }}
        >
          {title}
        </Typography>
        <Button
          onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
            e.stopPropagation();
            onButtonClick();
          }}
          variant="outlined"
          size="small"
          color="inherit"
          fullWidth
          sx={{ marginTop: "auto" }}
        >
          View Details
        </Button>
      </Box>
    </OsCard>
  );
}
